import {
  ApolloProvider as Provider,
  InMemoryCache,
  ApolloClient,
  // createHttpLink,
  split,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { WebSocketLink } from "@apollo/client/link/ws";
import { getMainDefinition } from "@apollo/client/utilities";
import { createUploadLink } from "apollo-upload-client";

let httpLink = createUploadLink({
  // uri: "http://localhost:4000",
  uri: "https://chat-app-mg.herokuapp.com/",
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = JSON.parse(localStorage.getItem("userGetToken"));
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

httpLink = authLink.concat(httpLink);

// subscription
const wsLink = new WebSocketLink({
  // uri: "ws://localhost:4000/graphql",
  uri: "wss://chat-app-mg.herokuapp.com/graphql",
  options: {
    reconnect: true,
    connectionParams: {
      Authorization: `Bearer ${JSON.parse(
        localStorage.getItem("userGetToken")
      )}`,
    },
  },
});

// this is function for whether this the query or mutation we gonna use the http link but if its not its gonna use the wsLink

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);


const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});

export default function ApolloProvider(props) {
  return <Provider client={client} {...props} />;
}
